import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  title: Yup.string().required("Titale is required!"),
  advertisement_images: Yup.string().required("Image is required!"),
  is_active: Yup.string().required("Status is required!"),
});
